module.exports = __webpack_public_path__ + "img/u1001.65a9e524.svg";